// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  padding: 2px 4px;
  font-size: 90%;
  color: #c7254e;
  background-color: #f9f2f4;
  border-radius: 4px;
}

:root {
  --rehype-github-alerts-default-color: rgb(89, 99, 110);
  --rehype-github-alerts-note-color: rgb(9, 105, 218);
  --rehype-github-alerts-tip-color: rgb(26, 127, 55);
  --rehype-github-alerts-important-color: rgb(130, 80, 223);
  --rehype-github-alerts-warning-color: rgb(154, 103, 0);
  --rehype-github-alerts-caution-color: rgb(209, 36, 47);
  --rehype-github-alerts-default-space: 1rem;
  --rehype-github-alerts-default-fontFamily:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  --rehype-github-alerts-default-fontWeight: 500;
}

@media (prefers-color-scheme: dark) {
  :root {
    --rehype-github-alerts-default-color: rgb(145, 152, 161);
    --rehype-github-alerts-note-color: rgb(68, 147, 248);
    --rehype-github-alerts-tip-color: rgb(63, 185, 80);
    --rehype-github-alerts-important-color: rgb(171, 125, 248);
    --rehype-github-alerts-warning-color: rgb(210, 153, 34);
    --rehype-github-alerts-caution-color: rgb(248, 81, 73);
  }
}

.markdown-alert {
  padding: calc(var(--rehype-github-alerts-default-space) / 2) var(--rehype-github-alerts-default-space);
  margin-bottom: var(--rehype-github-alerts-default-space);
  border-left: calc(var(--rehype-github-alerts-default-space) / 4) solid var(--rehype-github-alerts-default-color);
  font-family: var(--rehype-github-alerts-default-fontFamily);
}

.markdown-alert> :first-child {
  margin-top: 0;
}

.markdown-alert> :last-child {
  margin-bottom: 0;
}

.markdown-alert-note {
  border-left-color: var(--rehype-github-alerts-note-color);
}

.markdown-alert-tip {
  border-left-color: var(--rehype-github-alerts-tip-color);
}

.markdown-alert-important {
  border-left-color: var(--rehype-github-alerts-important-color);
}

.markdown-alert-warning {
  border-left-color: var(--rehype-github-alerts-warning-color);
}

.markdown-alert-caution {
  border-left-color: var(--rehype-github-alerts-caution-color);
}

.markdown-alert-title {
  display: flex;
  margin-bottom: calc(var(--rehype-github-alerts-default-space) / 4);
  align-items: center;
  font-weight: var(--rehype-github-alerts-default-fontWeight, 500);
}

.markdown-alert-note .markdown-alert-title {
  color: var(--rehype-github-alerts-note-color);
  fill: var(--rehype-github-alerts-note-color);
}

.markdown-alert-tip .markdown-alert-title {
  color: var(--rehype-github-alerts-tip-color);
  fill: var(--rehype-github-alerts-tip-color);
}

.markdown-alert-important .markdown-alert-title {
  color: var(--rehype-github-alerts-important-color);
  fill: var(--rehype-github-alerts-important-color);
}

.markdown-alert-warning .markdown-alert-title {
  color: var(--rehype-github-alerts-warning-color);
  fill: var(--rehype-github-alerts-warning-color);
}

.markdown-alert-caution .markdown-alert-title {
  color: var(--rehype-github-alerts-caution-color);
  fill: var(--rehype-github-alerts-caution-color);
}

.octicon {
  margin-right: calc(var(--rehype-github-alerts-default-space) / 2);
  display: inline-block;
  overflow: visible !important;
  vertical-align: text-bottom;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,mDAAmD;EACnD,kDAAkD;EAClD,yDAAyD;EACzD,sDAAsD;EACtD,sDAAsD;EACtD,0CAA0C;EAC1C;mIACiI;EACjI,8CAA8C;AAChD;;AAEA;EACE;IACE,wDAAwD;IACxD,oDAAoD;IACpD,kDAAkD;IAClD,0DAA0D;IAC1D,uDAAuD;IACvD,sDAAsD;EACxD;AACF;;AAEA;EACE,sGAAsG;EACtG,wDAAwD;EACxD,gHAAgH;EAChH,2DAA2D;AAC7D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,iEAAiE;EACjE,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px;\n}\n\n:root {\n  --rehype-github-alerts-default-color: rgb(89, 99, 110);\n  --rehype-github-alerts-note-color: rgb(9, 105, 218);\n  --rehype-github-alerts-tip-color: rgb(26, 127, 55);\n  --rehype-github-alerts-important-color: rgb(130, 80, 223);\n  --rehype-github-alerts-warning-color: rgb(154, 103, 0);\n  --rehype-github-alerts-caution-color: rgb(209, 36, 47);\n  --rehype-github-alerts-default-space: 1rem;\n  --rehype-github-alerts-default-fontFamily:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Noto Sans\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\";\n  --rehype-github-alerts-default-fontWeight: 500;\n}\n\n@media (prefers-color-scheme: dark) {\n  :root {\n    --rehype-github-alerts-default-color: rgb(145, 152, 161);\n    --rehype-github-alerts-note-color: rgb(68, 147, 248);\n    --rehype-github-alerts-tip-color: rgb(63, 185, 80);\n    --rehype-github-alerts-important-color: rgb(171, 125, 248);\n    --rehype-github-alerts-warning-color: rgb(210, 153, 34);\n    --rehype-github-alerts-caution-color: rgb(248, 81, 73);\n  }\n}\n\n.markdown-alert {\n  padding: calc(var(--rehype-github-alerts-default-space) / 2) var(--rehype-github-alerts-default-space);\n  margin-bottom: var(--rehype-github-alerts-default-space);\n  border-left: calc(var(--rehype-github-alerts-default-space) / 4) solid var(--rehype-github-alerts-default-color);\n  font-family: var(--rehype-github-alerts-default-fontFamily);\n}\n\n.markdown-alert> :first-child {\n  margin-top: 0;\n}\n\n.markdown-alert> :last-child {\n  margin-bottom: 0;\n}\n\n.markdown-alert-note {\n  border-left-color: var(--rehype-github-alerts-note-color);\n}\n\n.markdown-alert-tip {\n  border-left-color: var(--rehype-github-alerts-tip-color);\n}\n\n.markdown-alert-important {\n  border-left-color: var(--rehype-github-alerts-important-color);\n}\n\n.markdown-alert-warning {\n  border-left-color: var(--rehype-github-alerts-warning-color);\n}\n\n.markdown-alert-caution {\n  border-left-color: var(--rehype-github-alerts-caution-color);\n}\n\n.markdown-alert-title {\n  display: flex;\n  margin-bottom: calc(var(--rehype-github-alerts-default-space) / 4);\n  align-items: center;\n  font-weight: var(--rehype-github-alerts-default-fontWeight, 500);\n}\n\n.markdown-alert-note .markdown-alert-title {\n  color: var(--rehype-github-alerts-note-color);\n  fill: var(--rehype-github-alerts-note-color);\n}\n\n.markdown-alert-tip .markdown-alert-title {\n  color: var(--rehype-github-alerts-tip-color);\n  fill: var(--rehype-github-alerts-tip-color);\n}\n\n.markdown-alert-important .markdown-alert-title {\n  color: var(--rehype-github-alerts-important-color);\n  fill: var(--rehype-github-alerts-important-color);\n}\n\n.markdown-alert-warning .markdown-alert-title {\n  color: var(--rehype-github-alerts-warning-color);\n  fill: var(--rehype-github-alerts-warning-color);\n}\n\n.markdown-alert-caution .markdown-alert-title {\n  color: var(--rehype-github-alerts-caution-color);\n  fill: var(--rehype-github-alerts-caution-color);\n}\n\n.octicon {\n  margin-right: calc(var(--rehype-github-alerts-default-space) / 2);\n  display: inline-block;\n  overflow: visible !important;\n  vertical-align: text-bottom;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
